import { RouteRecordRaw } from "vue-router";

export const activityRoutes: RouteRecordRaw[] = [
  {
    path: "/activities/:id/edit",
    name: "ActivityEdit",
    component: () => import("../views/ActivityEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "activity",
      requiredRight: "viewUI",
    },
  },
];
